import { css } from '@emotion/react';
import { LocationDetails } from 'models';

import { theme } from '../theme';

const styles = {
  airport: css`
    white-space: nowrap;

    @media (max-width: ${theme.breakpoints.laptop}) {
      white-space: normal;
    }
  `,
  code: css`
    font-weight: ${theme.fontWeight.bold};
  `,
};

export function AirportName({ cityName, airportCode }: LocationDetails) {
  return (
    <div css={styles.airport}>
      <span>{cityName}</span> <span css={styles.code}>{airportCode}</span>
    </div>
  );
}
